<template>
  <div
    :style="{ backgroundImage: `url(${propSlide.slide_bg})`}"
    class="vgsi-slide-item"
  >
    <div class="vgsi-slide-content__wrap">
      <div class="vgsi-slide-content__box">
        <h6 class="vgsi-slide-content__sub-title">Our Solution</h6>
        <h2 class="vgsi-slide-content__title">
          {{ propSlide.slide_title }}
        </h2>
        <div class="vgsi-slide-content__desc">{{ propSlide.description }}</div>
        <div
          v-if="propSlide.button_is_active"
          :class="renderClass(propSlide.button_class)"
          v-html="propSlide.button_link"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Slide',
  props: {
    propSlide: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    renderClass (className) {
      return className.toLowerCase()
    }
  }
}
</script>

<style lang="scss">
$blue-color: #006893;
$black-color: #000;
/*--slider-*/
.cfs-hyperlink {
  background: $black-color;
  display: inline-block;
  color: #fff;
  text-transform: uppercase;
  font-size: 1rem;
  font-weight: bold;
  padding: 1rem 4rem;
  margin-top: 1.25rem;
  position: relative;
  transition: all 550ms ease;
  &:hover, &:active, &:focus{
    background: $blue-color;
    color: #fff;
  }
  span {
    position: relative;
  }
  span::after {
    content: '\f105';
    font-family: 'FontAwesome',sans-serif;
    display: block;
    position: absolute;
    right: -30px;
    top: -3px;
    color: #fff;
  }
}
/*--vgsi-slide--*/
.vgsi-slide{
  &-item {
    background-repeat: no-repeat;
    background-size: cover;
    background-position: top center;
    padding: 8.020833333333334vw 1rem;
    min-height: 70vh;
  }
  &-content{
    &__box {
      background: #fff;
      box-sizing: border-box;
      color: #333333;
      padding: 60px 30px;
      overflow: hidden;
      max-width: 520px;
    }
    &__sub-title{
      font-weight: bold;
    }
    &__title{
      margin-bottom: 1rem;
    }
  }
}

@media screen and (min-width: 992px) {
  /*--vgsi-slide--*/
  .vgsi-slide{
    &-content{
      &__box {
        // margin-left: 19.792vw;
        margin-left: 258px;
      }
    }
  }
}
@media screen and (min-width: 1366px) {
  /*--vgsi-slide--*/
  .vgsi-slide{
    &-content{
      &__box {
        margin-left: 20.70vw;
      }
    }
  }
}
@media screen and (min-width: 1440px) {
  .vgsi-slide{
    &-item {
      min-height: 74vh;
    }
  }
}
</style>
